import React from "react";
const Slide = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
export default Slide;